import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {composeWithDevTools} from 'redux-devtools-extension';
import {createRoot} from 'react-dom/client';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import {ThemeProvider} from '@mui/material';

import App from './App';
import theme from './mui-theme';
import './index.css';
import {NotificationContextProvider} from './context/NotificationContext';
import {rootReducer} from './redux/rootReducer';
import EnvironmentBanner from './ui/EnvironmentBanner';

const store = createStore(rootReducer, composeWithDevTools());

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <React.StrictMode>
                <BrowserRouter>
                    <NotificationContextProvider>
                        <EnvironmentBanner />
                        <App />
                    </NotificationContextProvider>
                </BrowserRouter>
            </React.StrictMode>
        </ThemeProvider>
    </Provider>,
);
